import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { injectIntl, FormattedMessage } from 'react-intl'
import { Text, Flex } from '@chakra-ui/react'
import { addOrRemoveArray } from 'src/utils/helpers'
import { Layout, Container, Content, PageTitle } from 'src/components/Layout'
import { FooterActionsParent } from 'src/components/Layout/Footer/FooterActions'
import List from 'src/components/List/List'
import Loader from 'src/components/Loader/Loader'
import Button from 'src/components/Button/Button'
import intlMessages from '../translations'

import styles from './styles.module.less'

class Policies extends Component {
  isMultiSelect = () => {
    const { policiesBillingType, isETransfer } = this.props

    return isETransfer === true && policiesBillingType === 'A'
  }

  handleBack = () => {
    const { history } = this.props
    if (history) {
      // Go home instead of back
      history.push('/')
    }
  }

  handleSelectPolicies = () => {
    const { history, selectedPaymentPolicies } = this.props

    if (!(selectedPaymentPolicies && selectedPaymentPolicies.length > 0)) {
      return false
    }

    if (history) {
      // Go to e-transfer page
      history.push('/payments/e-transfer')
    }
  }

  handlePolicySelect = policy => {
    const {
      history,
      selectedPaymentPolicies,
      setSelectedPaymentPolicies,
      isETransfer,
      isEPayPolicy,
    } = this.props

    const isMultiSelect = this.isMultiSelect()

    // Either adds or removes policy
    const selectedPolicies = isMultiSelect
      ? addOrRemoveArray(selectedPaymentPolicies, policy.policyValueId)
      : [policy.policyValueId]

    if (typeof setSelectedPaymentPolicies === 'function') {
      // Set selected policies to global redux store so we can have it on next page
      setSelectedPaymentPolicies(selectedPolicies)
    }

    // Exit so we don't redirect when it's multi select
    if (isMultiSelect) {
      return true
    }

    if (isEPayPolicy && policy.policyValueBillingType === 'A') {
      // Go to ePayPolicy page
      history.push('/payments/e-pay')
    }

    if (isETransfer && policy.policyValueBillingType === 'A') {
      // Go to e-transfer page
      history.push('/payments/e-transfer')
    }

    if (policy.policyValueBillingType === 'D') {
      // Go to Insurance Companies list
      history.push('/payments/insurances')
    }
  }

  getList = policies => {
    const { selectedPaymentPolicies } = this.props

    if (!(policies && policies.length > 0)) {
      return []
    }

    return policies.map(policy => {
      const icon =
        policy.category === 'auto' ? 'Vehicle' : policy.category === 'property' ? 'Property' : null

      const checked = selectedPaymentPolicies.includes(policy.id) ? true : false

      return {
        policyValueId: policy.id,
        policyValueBillingType: policy.billingType,
        leftIcon: this.isMultiSelect()
          ? selectedPaymentPolicies.includes(policy.id)
            ? 'Checked'
            : 'CheckedNo'
          : icon,
        topInfo:
          policy.hasOwnProperty('policyNumber') && policy.policyNumber.length > 0
            ? policy.policyNumber
            : '',
        name: policy.hasOwnProperty('label') && policy.label.length > 0 ? policy.label : '',
        description: policy.insurer,
        hideArrow: true,
        checked: this.isMultiSelect() ? checked : null,
      }
    })
  }

  render() {
    const { loading, paymentPolicies, intl, features, customNoPaymentOptionsLabel } = this.props

    const customPaymentErrorLabel =
      customNoPaymentOptionsLabel ?? 'Please contact your Broker for payment options.'

    const isMultiSelect = this.isMultiSelect()

    const foundedFeature = features.find(f => f.id == 'payments')
    const title =
      foundedFeature && foundedFeature.title
        ? foundedFeature.title
        : intl.formatMessage(intlMessages.paymentHeadline)

    return (
      <Layout>
        <Content>
          <PageTitle title={title} showBackMobile={true} />
          <Container padder className={styles.container}>
            {loading ? (
              <Loader styleVariation='staticWithHeight' />
            ) : paymentPolicies && paymentPolicies.length > 0 ? (
              <FooterActionsParent numButtons={isMultiSelect ? 1 : 0}>
                <Text
                  mt={'20px'}
                  variant='secondary'
                  fontWeight={500}
                  align={'center'}
                  fontSize={'14px'}
                >
                  {isMultiSelect ? (
                    <FormattedMessage
                      id='app.payment.policies.selectPoliciesText'
                      defaultMessage='Please select one or more policies and then tap on the next button.'
                    />
                  ) : (
                    <FormattedMessage
                      id='app.payment.policies.selectPolicyBelow'
                      defaultMessage='Please select policy below'
                    />
                  )}
                </Text>
                <List
                  items={this.getList(paymentPolicies)}
                  isColumn={true}
                  isColumnReverse={true}
                  className={styles.policiesList}
                  noMargin={true}
                  styleVariation='checklist'
                  onClick={this.handlePolicySelect}
                />
                {isMultiSelect ? (
                  <Flex
                    justify={'center'}
                    m={{ base: '0 20px', desktop: '0 auto' }}
                    w={{ base: 'auto', desktop: '350px' }}
                  >
                    <Button isFullWidth onClick={this.handleSelectPolicies}>
                      <FormattedMessage id='app.steps.next' defaultMessage='Next' />
                    </Button>
                  </Flex>
                ) : (
                  ''
                )}
              </FooterActionsParent>
            ) : (
              <h3 className={styles.noResults}>
                {!customNoPaymentOptionsLabel ? (
                  <FormattedMessage
                    id='app.payment.policies.noPoliciesFound'
                    defaultMessage={customPaymentErrorLabel}
                  />
                ) : (
                  <span dangerouslySetInnerHTML={{ __html: customNoPaymentOptionsLabel }}></span>
                )}
              </h3>
            )}
          </Container>
        </Content>
      </Layout>
    )
  }
}

export default withRouter(injectIntl(Policies))
